import { render } from "./MessageEmptyComponent.vue?vue&type=template&id=8b9c932a&scoped=true"
import script from "./MessageEmptyComponent.vue?vue&type=script&lang=js"
export * from "./MessageEmptyComponent.vue?vue&type=script&lang=js"

import "./MessageEmptyComponent.vue?vue&type=style&index=0&id=8b9c932a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9c932a"]])

export default __exports__